import React from 'react';
import Helmet from 'react-helmet';

export default ({
	title,
	id,
	image,
	url,
	brandName = 'Teddy Baldassarre',
	price,
}) => (
	<Helmet>
		<script text="text/javascript">{`
			var _learnq = _learnq || [];
		
			var item = {
				Name: '${title}',
				ProductID: '${id}',
				ImageURL: '${image}',
				URL: '${url}',
				Brand: '${brandName}',
				Price: '${price}',
			};
		
			_learnq.push(['track', 'Viewed Product', item]);

			_learnq.push(['trackViewedItem', {
				Title: item.Name,
				ItemId: item.ProductID,
				Categories: item.Categories,
				ImageUrl: item.ImageURL,
				Url: item.URL,
				Metadata: {
					Brand: item.Brand,
					Price: item.Price,
					CompareAtPrice: item.CompareAtPrice
				}
			}]);
		`}</script>
	</Helmet>
);